import { render } from "./questions-panel-header.vue?vue&type=template&id=4f588d5e&scoped=true&ts=true"
import script from "./questions-panel-header.vue?vue&type=script&lang=ts"
export * from "./questions-panel-header.vue?vue&type=script&lang=ts"

import "./questions-panel-header.vue?vue&type=style&index=0&id=4f588d5e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f588d5e"]])

export default __exports__